export default __webpack_public_path__ + "static/media/rosendo.48d9d876.png";